import React, { useState } from "react";
import Button from "../../../../reusable-components/buttons/Button";
import TableWrapper from "../../../../reusable-components/table/TableWrapper";
import { linkTextPrimary } from "../../../../theme/lightTheme";

import { SIZE_CONFIG_URL } from "../../../../api/api_routing_urls";
import axios from "../../../../api/axios";
import DeleteModal from "../../../../reusable-components/modals/DeleteModal";
import showToast from "../../../../utilities/notification/NotificationModal";
import { linkTextDanger } from "../../../../theme/lightTheme";

export default function SizeList({
  sizeList,
  getSizeList,
  setEditSizeDetails,
  setShowAddForm,
}) {
  const onClickEdit = (size) => {
    setEditSizeDetails(size);
    setShowAddForm(true);
  };

  const [showDelete, setShowDelete] = useState(false);
  const [sizeDeleteId, setSizeDeleteId] = useState(null);

  const onClickDelete = async () => {
    // console.log("Received ID to delete: ", sizeDeleteId);
    try {
      let response = "";
      if (sizeDeleteId) {
        response = await axios.post(`${SIZE_CONFIG_URL}/delete`, {
          size_id: sizeDeleteId,
        });
        setShowDelete(false);
      }

      if (response.status === 200) {
        showToast("Size details has been deleted successfully.", "success");
        getSizeList();
      } else {
        showToast("Size details deletion failed.", "error");
      }
    } catch (error) {
      console.log("Delete Module Error", error);
    } finally {
      setSizeDeleteId(null);
    }
  };

  return (
    <TableWrapper>
      <thead className="bg-white text-sm">
        <tr>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Sl No.
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Size Name
          </th>
          <th
            scope="col"
            className="pl-6 pr-9 py-3 text-right font-medium text-gray-900 uppercase tracking-wider"
          >
            Actions
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-100 text-gray-600">
        {sizeList?.length > 0 &&
          sizeList?.map((size, index) => (
            <tr key={index}>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {index+1}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {size.size_name}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                <div className="flex justify-end">
                  <Button
                    onClick={() => onClickEdit(size)}
                    aria-label="Edit Size Details"
                    className={linkTextPrimary}
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={() => {
                      setSizeDeleteId(size?.size_id || null);
                      setShowDelete(true);
                    }}
                    aria-label="Delete Size Details"
                    className={linkTextDanger}
                  >
                    Delete
                  </Button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>

      <>
        <DeleteModal
          open={showDelete}
          setOpen={setShowDelete}
          message={"This entry will be deleted. Are you sure?"}
          onDelete={onClickDelete}
        />
      </>
    </TableWrapper>
  );
}
